import { render, staticRenderFns } from "./SelectGenre.vue?vue&type=template&id=7a41c3e6&scoped=true&"
import script from "./SelectGenre.vue?vue&type=script&lang=js&"
export * from "./SelectGenre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a41c3e6",
  null
  
)

export default component.exports